module.exports = __webpack_public_path__ + "img/logo2.bf613409.png";